module.exports = __webpack_public_path__ + "static/media/chatbutton.eb3b42c3.svg";